<template lang="pug">
.release-version(:class="releaseVersionClasses")
  .release-version-panel
    .release-details
      .version-number
        | Version: {{ release.version }}
      .version-release
        | Released: {{ $filters.formatDate(release.released_on) }}
    .release-controls
      a.version-download(:href="release.url")
        | Download
      .divider
      i.hi-caret(@click="toggleChangelog")
  .release-changelog
    strong Changelog
    AppMarkdown(:markdown="release.changelog")
</template>

<script>
import AppMarkdown from '../AppMarkdown.vue';

export default {
  name: 'ClientDownloadPanel',
  components: { AppMarkdown },
  props: {
    release: {
      type: Object,
    },
  },
  data: () => ({
    opened: false,
  }),
  computed: {
    releaseVersionClasses() {
      return this.opened ? 'opened' : '';
    },
  },
  methods: {
    toggleChangelog() {
      this.opened = !this.opened;
    },
  },
};
</script>
